// 销售员管理和客户管理列表
export default [
    // 销售员管理
    {
        path: "salesmanList",
        name: "salesmanmanage",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/manages/salesman/index"),
        
    },
    // 销售员管理编辑查看
    {
        path: "salesmanList/upadte/:type",
        name: "salesmanupdate",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/manages/salesman/update"),
        
    },
    // 客户管理列表
    {
        path: "customerList",
        name: "customermanage",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/manages/customer/index"),
        
    },
    // 客户管理编辑查看
    {
        path: "customerList/upadte/:type",
        name: "customerupdate",
        component: () => import(/* webpackChunkName: "manage" */ "@/views/manages/customer/update"),
        
    },
]